import {
  GetDeviceSnapshotDTO,
  GetDeviceSnapshotQuery,
  GetDeviceSnapshotResponse,
} from '@eppendorf/vnls-device-service-utils';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { fetcher } from '$shared/fetch';
import { queryClient } from '$shared/query/query-client';
import { DEVICE_SERVICE_BASE_PATH } from '$shared/utils/api-paths';

export const deviceSnapshotQueryKey = 'deviceSnapshot';

export const createDeviceSnapshotQuery = (params: GetDeviceSnapshotQuery) => ({
  queryKey: [deviceSnapshotQueryKey, params.manufacturer, params.serialNumber],
  queryFn: async () => {
    const response = await fetcher.get<GetDeviceSnapshotResponse>(
      `${DEVICE_SERVICE_BASE_PATH}/${params.manufacturer}/${params.serialNumber}/snapshot`,
    );

    return response;
  },
  placeholderData: keepPreviousData,
  refetchInterval: 5000,
});

export const useDeviceSnapshot = (params: GetDeviceSnapshotQuery, enabled = true) => {
  const snapshotQuery = createDeviceSnapshotQuery(params);
  return {
    ...useQuery({ ...snapshotQuery, enabled }),
    invalidate: async (): Promise<GetDeviceSnapshotDTO> => {
      await queryClient.invalidateQueries({
        queryKey: [deviceSnapshotQueryKey, params.manufacturer, params.serialNumber],
      });

      return queryClient.fetchQuery(snapshotQuery);
    },
  };
};
